module.exports = __webpack_public_path__ + "img/WESicon2.790c60a5.png";